import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// cn merges Tailwind class strings sensibly — clsx for boolean
// composition, twMerge to dedupe conflicting utility classes. Same
// helper web-client and web-backoffice use.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
